import { render } from "./studyversiondiff.vue?vue&type=template&id=0f58aa2f&scoped=true&ts=true"
import script from "./studyversiondiff.js?vue&type=script&lang=ts"
export * from "./studyversiondiff.js?vue&type=script&lang=ts"

import "./studyversiondiff.vue?vue&type=style&index=0&id=0f58aa2f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f58aa2f"]])

export default __exports__